import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { spacing } from 'ui/theme';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
  margin: ${spacing.base} 0;
  & > :not(span) {
    width: 100%;
  }
`;

export const OrDivider = () => (
  <Wrapper>
    <Divider />
    <span>OR</span>
    <Divider />
  </Wrapper>
);
